<template>
  <div no-body>
    <b-row>
      <b-col lg="12">
        <b-form-group label-cols="1" label="Filter">
          <b-row>
            <b-col class="pl-1 pr-1"
              ><b-form-input
                v-model="tblData.customerID"
                placeholder="Customer Id"
              ></b-form-input
            ></b-col>
            <b-col class="pl-1 pr-1"
              ><b-form-input
                v-model="tblData.debtorFullName"
                placeholder="Debitur Fullname"
              ></b-form-input
            ></b-col>
            <b-col class="pl-1 pr-1"
              ><b-form-input
                v-model="tblData.motherMaidenName"
                placeholder="Mother Maiden Name"
              ></b-form-input
            ></b-col>
            <b-col
              ><b-button variant="success mr-1" @click="refresh()"
                ><i class="fa fa-search"></i> Search</b-button
              ></b-col
            >
          </b-row>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table
      class="mb-0"
      ref="tblVendor"
      responsive
      striped
      hover
      small
      style="font-size: smaller"
      :items="tblData.items"
      :fields="fields"
      :current-page="tblData.page"
      :per-page="tblData.limit"
      :sort-by.sync="tblData.sortBy"
      :sort-desc.sync="tblData.sortDesc"
      :key="tblData.limit"
      @row-clicked="selectItem"
      :busy="isBusy"
    >
      <template v-slot:cell(index)="data">{{
        (tblData.page - 1) * tblData.limit + (data.index + 1)
      }}</template>
      <template v-slot:cell(dateOfBirth)="data">{{
        data.item.dateOfBirth | moment("YYYY-MM-DD")
      }}</template>
      <template v-slot:cell(genderCode)="data">
        <span v-if="data.item.genderCode == 'L'">Male</span>
        <span v-else-if="data.item.genderCode == 'P'">Female</span>
      </template>
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
    </b-table>
    <b-row>
      <b-col cols="4">
        <div class="pt-2">
          Showing {{ (tblData.page - 1) * tblData.limit + 1 }} to
          <span v-if="tblData.page * tblData.limit > tblData.total">{{
            tblData.total
          }}</span>
          <span v-else>{{ tblData.page * tblData.limit }}</span> of
          {{ tblData.total }} entries
        </div>
      </b-col>
      <b-col cols="3">
        <b-row class="ml-2 mt-2">
          <span class="pt-1 pr-2">Limit per page</span>
          <b-form-select
            :options="[10, 15, 20, 25]"
            :plain="true"
            v-model="tblData.limit"
            size="sm"
            style="width: 80px !important"
          />
        </b-row>
      </b-col>
      <b-col cols="5">
        <b-pagination
          align="right"
          :total-rows="tblData.total"
          :per-page="tblData.limit"
          v-model="tblData.page"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import crud from "../../apis/crud";

export default {
  data() {
    return {
      fields: [
        {
          key: "index",
          label: "No.",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "customerID",
          label: "Customer ID",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "debtorFullName",
          label: "FullName",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "genderCode",
          label: "Gender Code",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "idNumber",
          label: "No. KTP",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "placeOfBirth",
          label: "Place Of Birth",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "dateOfBirth",
          label: "Date Of Birth",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "employerName",
          label: "Employer Name",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "motherMaidenName",
          label: "Mother Maiden Name",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        },
      ],
      tblData: {
        items:[],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "customerID",
        sortDesc: false,
        tablename: "borrowercrud",
        customQuery: "",
        debtorFullName: "",
        motherMaidenName: "",
        customerID: "",
      },
      isBusy: false,
    };
  },
  computed: {
    filterKode() {
      return this.tblData.username;
    },
    filterNamaAcc() {
      return this.tblData.full_name;
    },
  },
  watch: {
    filterKode: function (kode) {
      setTimeout(() => {
        if (kode == this.tblData.username) this.refresh();
      }, 500);
    },
    filterNamaAcc: function (full_name) {
      setTimeout(() => {
        if (full_name == this.tblData.full_name) this.refresh();
      }, 500);
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function (ctx) {
      const searchkey = ["debtorFullName", "motherMaidenName", "customerID"];
      this.tblData.items =[];
      this.tblData.length = 0;
      this.tblData.customQuery = "";
      searchkey.map((key) => {
        if (this.tblData[key]) {
          this.tblData.customQuery += this.tblData.customQuery ? "&" : "?";
          this.tblData.customQuery = `${key}=${encodeURIComponent(
            this.tblData[key].trim()
          )}`;
        }
      });
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.isBusy = true;
      const list = await crud.list(this.tblData);
      this.isBusy = false;
      this.tblData.items =list;
      this.tblData.length = list.length;
      // return list;
    },
    selectItem(item, index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("click", item);
    },
    refresh() {
      this.data();
      // this.$refs.tblVendor.refresh();
    },
  },
};
</script>
